import styled from '@emotion/styled';

export const ModalContainer = styled.div({
  maxWidth: '540px',
});
